import { render, staticRenderFns } from "./AuthInfoPopup.vue?vue&type=template&id=2a1e4924"
import script from "./AuthInfoPopup.vue?vue&type=script&lang=js"
export * from "./AuthInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./AuthInfoPopup.vue?vue&type=style&index=0&id=2a1e4924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports